/**
 * main.js - 应用入口文件
 * 功能：初始化 Vue 实例，注册全局插件（ElementUI、axios、router、store），挂载到 #app
 * 主要依赖：vue, vue-router, vuex, element-ui, axios
 */

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

// 配置 axios 全局默认值
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/api' : '/api'

Vue.use(ElementUI)
Vue.prototype.$http = axios // 将 axios 挂载到 Vue 原型，供组件通过 this.$http 使用
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
